import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicSelect from '../BasicSelect';

const SetupEmailDropdown = props => {
  const { value, options, controlFunc, touchFunc } = props;
  return (
    <div className="setup-email-dropdown">
      <h4 className="email-setup-dropdown__title">
        Requirement from Email Setup
      </h4>

      <BasicSelect
        isSearchable={false}
        name="setup-email-dropdown"
        value={value}
        isValid={true}
        options={options}
        placeholder="Select Requirement"
        controlFunc={controlFunc}
        touchFunc={touchFunc}
        isLast={false}
      />
    </div>
  );
};

SetupEmailDropdown.propTypes = {
  value: PropTypes.object,
  options: PropTypes.array.isRequired,
  controlFunc: PropTypes.func.isRequired,
  touchFunc: PropTypes.func,
};

export default SetupEmailDropdown;
